import { CdkMonitorFocus } from '@angular/cdk/a11y';
import { Directive, input } from '@angular/core';

/**
 * Estilo plano de los controles de la barra de filtros (rango de fechas, "Filtrar por", selectores).
 * Píldora de 36 px con borde gris y sin sombra; en móvil es un círculo que muestra solo el ícono,
 * así que los textos del control deben ocultarse bajo `md` desde la plantilla que lo usa.
 * Texto en Rubik gris oscuro; los valores secundarios (fechas, chevron) van en gris claro desde la plantilla.
 * Rubik se repite en los `span` porque general.scss les fija Yantramanav; no se usa `[&_*]` para no pisar
 * la fuente de los íconos de Font Awesome.
 * Los popovers que abre el control conservan su propia sombra.
 * El foco usa el anillo nativo del navegador solo con teclado; anula el outline gris que
 * general.scss pone en todo `button:focus`, que también aparecía al hacer clic.
 * CdkMonitorFocus marca el origen del foco: cuando mat-menu devuelve el foco tras abrirse con el mouse,
 * el navegador lo trata como :focus-visible, así que con `cdk-mouse-focused` se oculta el anillo.
 */
@Directive({
  selector: '[mhFilterTrigger]',
  standalone: true,
  hostDirectives: [CdkMonitorFocus],
  host: {
    class:
      'tw-inline-flex tw-h-9 tw-w-9 tw-shrink-0 tw-items-center tw-justify-center tw-gap-1.5 tw-rounded-full ' +
      'tw-border-[0.5px] tw-border-solid tw-border-border-light-gray tw-bg-white tw-font-rubik tw-text-[13px] ' +
      'tw-font-normal [&_span]:tw-font-rubik tw-text-neutral-800 tw-transition-colors hover:tw-bg-gray-50 disabled:tw-cursor-not-allowed disabled:tw-opacity-60 ' +
      '[&:not(:focus-visible)]:tw-outline-none focus-visible:[outline:auto] [&.cdk-mouse-focused]:!tw-outline-none',
    '[class.!tw-bg-gray-50]': 'filterOpen()',
    '[class.md:tw-w-fit]': '!filterIconOnly()',
    '[class.md:tw-px-3]': '!filterIconOnly()',
  },
})
export class FilterTriggerDirective {
  /** Con el popover abierto el control se ve igual que en hover. */
  readonly filterOpen = input(false);

  /** Botones de solo ícono (p. ej. limpiar filtros): círculo de 36 px en todos los tamaños. */
  readonly filterIconOnly = input(false);
}
